import React from "react";
import { Box, Typography } from "@mui/material";
import WorkflowPifTextField from "./WorkflowPifTextField";
import WorkflowPifSelectField from "./WorkflowPifSelectField";
import { PifOption, PifSectionProps } from "./pifDetailsModel";
import { PIF_DETAILS_FIELDS, PIF_REFERRAL_SOURCES } from "./pifWorkflowKeys";

const F = PIF_DETAILS_FIELDS;

/** Today's PostIF referral options, in PostIF's order (P6). */
const REFERRAL_SOURCES: PifOption[] = [
  { id: PIF_REFERRAL_SOURCES.employeeReferral, text: "Employee Referral" },
  { id: PIF_REFERRAL_SOURCES.jobBoard, text: "Job Board" },
  { id: PIF_REFERRAL_SOURCES.walkIn, text: "Walk-in" },
  { id: PIF_REFERRAL_SOURCES.other, text: "Other" },
];

/** pif-3 Additional. Referral source is optional, and a choice from PostIF's referral list. */
const WorkflowPifAdditionalSection: React.FC<PifSectionProps> = ({ values, errors, onChange }) => {
  const field = { values, errors, onChange };
  return (
    <>
      <Typography component="h3" className="workflow-run__section-title">
        Additional
      </Typography>
      <Box className="workflow-run__grid">
        <WorkflowPifTextField
          {...field}
          fieldKey={F.emergencyContactNumber}
          label="Emergency contact number"
          required
          inputMode="numeric"
          maxLength={30}
          hint="Digits only."
        />
        <WorkflowPifSelectField
          {...field}
          fieldKey={F.referralSource}
          label="Referral source"
          options={REFERRAL_SOURCES}
          placeholder="Choose one…"
        />
      </Box>
    </>
  );
};

export default WorkflowPifAdditionalSection;
